import { render, staticRenderFns } from "./broadcastList.vue?vue&type=template&id=1858bf35&scoped=true&"
import script from "./broadcastList.vue?vue&type=script&lang=js&"
export * from "./broadcastList.vue?vue&type=script&lang=js&"
import style0 from "./broadcastList.vue?vue&type=style&index=0&id=1858bf35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858bf35",
  null
  
)

export default component.exports